import './App.css';
import React from 'react';
import { BrowserRouter as Router, Navigate, useLocation } from 'react-router-dom';
import { LanguageProvider } from './jobseeker/contexts/LanguageContext';
import JobSeekerApp from './jobseeker/JobSeekerApp';
import './styles/jobseeker/theme.css';
import './styles/jobseeker/onboarding-theme.css';
import './styles/jobseeker/mobile.css';
import './styles/jobseeker/mobile-readability.css';

function AppRoutes() {
  const location = useLocation();
  if (location.pathname.startsWith('/__preview/')) {
    return <Navigate to="/opportunities" replace />;
  }
  return <JobSeekerApp />;
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <AppRoutes />
      </Router>
    </LanguageProvider>
  );
}

export default App;
